export default __webpack_public_path__ + "static/media/Spring21_11.3bbbcf2c.png";